import React from 'react';
import { PRODUCT_WIDGET_LAYOUT_TYPE_V2, ProductWidgetDetailV2 } from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import PreviewGrid from '../../../../../../../components/preview/PreviewGrid';
import { ProductWidgetGallaryLayoutStyle } from './style';

export type ProductWidgetGalleryLayoutDetail = ProductWidgetDetailV2 & {
  layoutType: typeof PRODUCT_WIDGET_LAYOUT_TYPE_V2.GALLERY_3X3;
};

interface ProductWidgetGalleryLayoutProps {
  detail: ProductWidgetGalleryLayoutDetail;
}
const ProductWidgetGalleryLayout = (props: ProductWidgetGalleryLayoutProps) => {
  const { detail } = props;

  return (
    <ProductWidgetGallaryLayoutStyle>
      <PreviewGrid col={3} colGap={2} rowGap={2}>
        {detail.widgetItemProducts
          ?.slice(0, 9)
          .map((productItem) => <Img key={productItem.id} clickAble={false} src={productItem.imageUrl} />)}
      </PreviewGrid>
    </ProductWidgetGallaryLayoutStyle>
  );
};

export default ProductWidgetGalleryLayout;
